"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logEvent = exports.removeProperty = exports.setProperty = exports.AmplitudeInit = void 0;
const amplitude = require("amplitude-js");
const amplitudeInstance = amplitude.getInstance();
/**
 * Set used to track logged events.
 * React updates components several times,
 * meaning that we would log the same event
 * multiple times if we do not check them with
 * a set.
 */
const events = new Set();
/**
 * Initialises Amplitude
 * @param apiKey key can be found in analytics.amplitude.com/tractable
 */
function AmplitudeInit(apiKey) {
    amplitudeInstance.init(apiKey);
}
exports.AmplitudeInit = AmplitudeInit;
// Reference object for continuous logging.
const CONTINUOUS_PROPS = {};
/**
 * Sets a permanent/continuous logging property.
 *
 * Example: If we set ('client', 'tractable'), every time
 * we call logEvent(event, data), the 'client' property
 * will be logged as well.
 *
 * @param name property name
 * @param value property value
 */
function setProperty(name, value) {
    CONTINUOUS_PROPS[name] = value;
}
exports.setProperty = setProperty;
/**
 * Removes a permanent/continuous logging property.
 *
 * @param name property name to remove
 */
function removeProperty(name) {
    delete CONTINUOUS_PROPS[name];
}
exports.removeProperty = removeProperty;
/**
 * Logs an event to Amplitude.
 * Events & more available at analytics.amplitude.com/tractable
 * @param event string to identify the event
 * @param data Event object with string keys and string || number values
 */
function logEvent(event, data) {
    // TODO: Should event be a variant to limit scope?
    // e.g. type Event = "Welcome" || "Onboarding"
    const env = process.env.NODE_ENV;
    if (env !== 'production')
        return;
    if (events.has(event))
        return;
    events.add(event);
    amplitudeInstance.logEvent(event, { ...CONTINUOUS_PROPS, ...data, env });
}
exports.logEvent = logEvent;
//# sourceMappingURL=index.js.map